import dayjs from "dayjs";
import React, { FC } from "react";

interface DateWithTimeRowProps {
  text: string;
  format?: "withSeconds" | "withoutSeconds";
}

const DateWithTimeRow: FC<DateWithTimeRowProps> = ({
  text,
  format = "withSeconds",
}) => {
  const timezone = localStorage.getItem("timezone");

  const dateFormat =
    format === "withSeconds" ? "YYYY-MM-DD HH:mm:ss" : "YYYY-MM-DD HH:mm";

  return (
    <span>
      {dayjs(text)
        .tz(timezone ?? "UTC")
        .format(dateFormat)}
    </span>
  );
};

export { DateWithTimeRow };
